import { render, staticRenderFns } from "./PagedItemsRaw.vue?vue&type=template&id=0de896f6&scoped=true&"
import script from "./PagedItemsRaw.vue?vue&type=script&lang=js&"
export * from "./PagedItemsRaw.vue?vue&type=script&lang=js&"
import style0 from "./PagedItemsRaw.vue?vue&type=style&index=0&id=0de896f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de896f6",
  null
  
)

export default component.exports